// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"ce08c5e0","186":"97ed22f9","344":"6d6f262b","372":"2341a246","738":"0b7b7f0b","841":"a0fc8213","851":"0f26470e","856":"fd195d43"}[chunkId] + ".chunk.js";
};